<div class="item-menu bouton-liste-contacts" [class.active]="state">
	<i class="icon-users"
	   (click)="onClick.emit();"
	   *ngIf="contactsLength > 0"></i>
	<i class="icon-users disabled"
	   *ngIf="contactsLength == 0"></i>
	<span *ngIf="contactsLength > 0" class="badge color-1">{{contactsLength}}</span>
</div>